import { CardNumber, Cvv, ExpiryDate, Frames } from "frames-react";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../api/phx";
import { getDomainConfig } from "../../config/config";
import { ABContext } from "../../contexts/ab-context";
import { OrderContext } from "../../contexts/order-context";
import { OrderSummaryContext } from "../../contexts/order-summary-context";
import { useCart } from "../../hooks/useCart";
import { useSettings } from "../../hooks/useSettings";
import { getLanguageCode } from "../../utils/getURLParams";
import GiftCard from "../GiftCard/GiftCard";
import { applyGiftCards } from "../GiftCard/applyGiftCards";
import SubTotal from "../SubTotal/SubTotal";
import StandardBlockInfo from "../UI/StandardBlockInfo";
import StandardFieldset from "../UI/StandardFieldset";
import StandardH2 from "../UI/StandardH2";
import StandardH3 from "../UI/StandardH3";
import StandardH4 from "../UI/StandardH4";
import StandardValidation from "../UI/StandardValidation";
import idealLogo from "./IDEAL.png";
import CvvImg from "./cvv.jpg";
import AlertTriangle from "./alert-fill.svg"
import { ApplePayTabInfo } from "../ApplePay/ApplePayTabInfo";
import { countryCode } from "../../utils/countryCode";
import {ReactComponent as CardIcon} from '../../images/global/tab-card.svg';
import {ReactComponent as GiftIcon} from '../../images/global/tab-gift.svg';
import {ReactComponent as LockIcon} from '../../images/global/lock.svg';
import {ReactComponent as Cro1381CardVisaIcon} from '../../images/global/cro1381-card-visa.svg';
import {ReactComponent as Cro1381CardMastercardIcon} from '../../images/global/cro1381-card-mastercard.svg';
import {ReactComponent as Cro1381CardAmexIcon} from '../../images/global/cro1381-card-amex.svg';
import {ReactComponent as Cro1381PaypalIcon} from '../../images/global/cro1381-paypal.svg';
import {ReactComponent as Cro1381IdealIcon} from '../../images/global/cro1381-ideal-icon.svg';
import {ReactComponent as Cro1381BlackGiftIcon} from '../../images/global/cro1381-black-gift-icon.svg';
import {ReactComponent as Cro1381GiroPayIcon} from '../../images/global/cro1381-giro-pay-icon.svg';
import {ReactComponent as Cro1381ApplePayIcon} from '../../images/global/cro1381-applepay.svg';
import {ReactComponent as Cro1381GooglePayIcon} from '../../images/global/google-pay-mark_800.svg';
import { DepDateContext } from '../../contexts/dep-date-context';
import { differenceInCalendarDays, parseISO } from "date-fns";
import Cookies from "js-cookie";
import { googleDataLayer } from "../Analytics/Universal/PageView/googleDataLayer";
import { markOrderPaymentStatusFailed } from "../../utils/markPaymentAsFailed";
import PaypalV3 from "../Paypal/PaypalV3";
import ReactModal from 'react-modal';
import visaIcon from '../../images/card-icons/visa.svg';
import mastercardIcon from '../../images/card-icons/mastercard.svg';
import amexIcon from '../../images/card-icons/americanexpress.svg';
import dinersclubIcon from '../../images/card-icons/dinersclub.svg';
import discoverIcon from '../../images/card-icons/discover.svg';
import jcbIcon from '../../images/card-icons/jcb.svg';
import madaIcon from '../../images/card-icons/mada.svg';
import maestroIcon from '../../images/card-icons/maestro.svg';
import cardErrorIcon from '../../images/card-icons/error.svg';
import { GooglePayInfo } from "../GooglePay/GooglePayInfo";
import isABTest from "../../ab/isabtest";
import { PublicKey } from "../GooglePay/googlePay";
import {ReactComponent as Messaging3DSLogoIcon} from '../../images/global/at.svg';
import { Logs } from "../../utils/logs";
import ExitPopUp from '../../utils/exitPopUp';

const PaymentDetails = (props) => {
  const config = getDomainConfig();
  const { t } = useTranslation("common");

  const country_code = countryCode();

  /* LOADING THE BRANDED SCSS */
  const [styles, setStyles] = useState(false);
  useEffect(() => {
    const getStyles = async (theFileName, theFileEnd) => {
      if (config.brand) {
        let moduleStyles = false;
        try {
          moduleStyles = await import(
            "./" + theFileName + config.brand + theFileEnd
          );
          setStyles(moduleStyles);
        } catch (e) {
          console.error(
            `Styles for ${theFileName} could not be loaded, ${e.message}`
          );
        }
      }
    };
    // Specify file name and end of file name here.
    getStyles("PaymentDetails", ".module.scss");
  }, [config.brand]);
  /* END LOADING THE BRANDED SCSS */
  const { orderSummary } = useContext(OrderSummaryContext);
  const abContext = useContext(ABContext);
  const orderContext = useContext(OrderContext);
  const [cardToken, setCardToken] = useState("");
  const [cardholder, setCardHolder] = useState({
    name: "",
    phone: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    zip: "",
    state: "",
    country: "",
  });
  const [showApplePay,setShowApplePay] = useState(false)
  const [paymentIsValid, setPaymentIsValid] = useState(false);
  const [paymentError, setPaymentError] = useState(false);
  const [showCardValidationError, setShowCardValidationError] = useState(false)
  const [showCardExpiryValidationError, setShowCardExpiryValidationError] = useState(false)
  const [showCardCvvValidationError, setShowCardCvvValidationError] = useState(false)
  const [amountToPay, setAmountToPay] = useState(0);
  const [showCVVInfo, setShowCVVInfo] = useState(false);
  const [show3DSIframe, setShow3DSIframe] = useState(false);
  const [showPaypalBlock, setShowPaypalBlock] = useState(false);
  const [showGiftCardBlock, setShowGiftCardBlock] = useState(false);
  const [showGiroPayBlock, setShowGiroPayBlock] = useState(false);
  const [showIdealPayBlock, setShowIdealPayBlock] = useState(false);
  const [showCardBlock, setShowCardBlock] = useState(true);
  const [showGooglePay, setShowGooglePay] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  let cartMeta = [];
  let publicKey = "";
  let total_gift_cards_balance;
  let CKOversion = 0;

  const [payment_methods, setPaymentMethods] = useState([]);
  const [activePaymentMethod, setActivePaymentMethod] = useState("card");
  const [loading, setLoading] = useState(false)
  const { depDate } = useContext(DepDateContext);
  const [cardAccepted, setCardAccepted] = useState(true);

  // Payment Tabs states
  const [activeTab, setActiveTab] = useState("payment-form");
  const [activeTabContent, setActiveTabContent] = useState("payment-form");
  const [activePaymentAction, setActivePaymentAction] = useState("card");
  const [showPayPal,setShowPayPal] = useState(false);
  const payPalLimitDays = 3;

  // Success and failure handlers for payments.
  const handlePaymentSuccess = () => {

    if (cartContents.meta.total_gift_card_balance > 0) {
      applyGiftCards(
        orderContext.orderId,
        cartContents.data.gift_cards,
        cartContents.meta.total_price
      )
    }
    // Clearing current cart
    config.brand === "Atd" && API.delete("/cart");
    // Cookies below are assigned if payment was not flagged or risked. Is for Global order complete page to display correct information for the user.
    Cookies.set('orderDoComplete',true);
    Cookies.set('risk',false);
    Cookies.set('flagged',false);
    Cookies.set('display',true);
    setLoading(true);

    ExitPopUp.Disable();
    // Redirect to complete page:
    window.location.href = `${getLanguageCode(
      config.brand,
      true
    )}/cart/checkout/complete/${orderContext.orderId}`;
  };

  const riskCallback = () => {

    let completePath = 'complete';
    if (config.brand === 'Atd') {
      // Clearing current cart
      API.delete('/cart');
      completePath = 'incomplete';
    }

    // Replicated logic from Global checkout for flagged payment.
    // Assigning expected cookies for Global order confirmation page to display correct message to the user.
    Cookies.set('orderDoComplete',false);
    Cookies.set('flagged',true);
    Cookies.set('display',false);
    setLoading(true);

    ExitPopUp.Disable();
    window.location.href = `${getLanguageCode(
      config.brand,
      true
    )}/cart/checkout/${completePath}/${orderContext.orderId}`;
  };

  useEffect(() => {
    setShow3DSIframe(props.openModal);
  }, [props.openModal])

  useEffect(() => {
    // Pass needed variables back up to the Form component.
    props.func(paymentIsValid, activePaymentMethod, cardAccepted);
    props.paymentErrorFunc(paymentError);
  }, [paymentIsValid, activePaymentMethod, cardAccepted]);

  /** Handle redirect back to checkout page after a failed payment. */
  function failureCallback() {
    setPaymentError(true);
    setShow3DSIframe(false);
    // Enable the form to be submitted again.
    Frames.enableSubmitForm();
    let completePath = 'incomplete';

    if (config.brand === "Atd") {
      //Changing order status to 'payment failed' in phx
      markOrderPaymentStatusFailed(orderContext.orderId).then(() => {
        setLoading(true);
        completePath = 'incomplete';
        Cookies.set('orderDoComplete',false);
        Cookies.set('display',false);
        API.delete("/cart").then(() => {
          ExitPopUp.Disable();
          window.location.href = `${getLanguageCode(
            config.brand,
            true
          )}/cart/checkout/${completePath}/${orderContext.orderId}`;
        });
      });
    } else {
      ExitPopUp.Disable();
      window.location.href = `${getLanguageCode(
        config.brand,
        true
      )}/cart/checkout/${completePath}/${orderContext.orderId}`;
    }
  }

  window.top.checkoutDotComSuccess = handlePaymentSuccess;
  window.top.checkoutDotComFailure = failureCallback;
  window.top.checkoutDotComRisk = riskCallback;

  const { isSuccess: cartIsSuccess, data: cartContents } = useCart();
  const { isSuccess: settingsIsSuccess, data: settingsData } = useSettings();

  if (cartIsSuccess) {
    cartMeta = cartContents.meta;
    total_gift_cards_balance = cartContents.meta.total_gift_card_balance;
  }

  if (settingsIsSuccess) {
    publicKey = settingsData.public_key;
    CKOversion = +settingsData.version;
    PublicKey.SetPublicKey(publicKey);
  }

  // Once we have the order update the card holder details
  useEffect(() => {
    // Update the Billing address
    if (Object.keys(orderContext).length > 0) {
      setCardHolder({
        name: `${orderContext.order.billing_address_fname} ${orderContext.order.billing_address_lname}`,
        phone: orderContext.order.billing_address_phone,
        addressLine1: orderContext.order.billing_address_street1,
        addressLine2: orderContext.order.billing_address_street2,
        city: orderContext.order.billing_address_city,
        zip: orderContext.order.billing_address_postal_code,
        state: orderContext.order.billing_address_region,
        country: orderContext.order.billing_address_country,
      });
    }
  }, [orderContext]);

  // Submit the card when the cardholder details are updated.
  useEffect(() => {
    if (cardholder.name !== "" && paymentIsValid && cardAccepted) {
      Frames.submitCard();
    }
  }, [cardholder, paymentIsValid, cardAccepted]);

  const handlePayment = (method, action, cardToken) => {
    const orderId = orderContext.orderId;
    const email = orderContext.order.email;

    // For checkout.com we need to add the zeros.
    const amountToPay = (orderSummary.total * 100).toFixed();
    const data = {
      email: email,
      billing_address_fname: orderContext.order.billing_address_fname,
      billing_address_lname: orderContext.order.billing_address_lname,
      billing_address_street1: orderContext.orderbilling_address_street1,
      billing_address_street: orderContext.orderbilling_address_street2,
      billing_address_region: orderContext.order.billing_address_region,
      billing_address_country: orderContext.order.billing_address_country,
      billing_address_postal_code:
        orderContext.order.billing_address_postal_code,
      value: amountToPay,
      currency: cartMeta.sale_cur,
      trackid: orderId,
      cardToken,
    };

    // Submit capture request:
    const checkoutUrl = btoa(window.location.href);
    const path = `/payments/checkoutdotcom/${method}?action=${action}&account=0&checkout_url=${checkoutUrl}&order_id=${orderId}`;
    let redirectUrl;

    if (parseFloat(amountToPay) > 0) {

      Logs.AddProvisionalEvent(`Payment API - START`);
      API.post(path, data, { mode: "no-cors" }).then(
        (response) => {

          Logs.AddProvisionalEvent(`Payment API - DONE`);
          const result = response.data;
          if (
            result.response_summary &&
            result.response_summary === "Risk Blocked Transaction"
          ) {
            // Clearing current cart
            config.brand === "Atd" && API.delete("/cart");

            //Cookies assigned when payment failed (3ds check or any other reason)
            Cookies.set('orderDoComplete',false);
            Cookies.set('display',false);

            ExitPopUp.Disable();
            window.location.href = `${getLanguageCode(
              config.brand,
              true
            )}/cart/checkout/complete/${orderId}`;
          } else if (result && "_links" in result) {
              if (!("redirect" in result._links)) {
                failureCallback();
                return;
              }
              redirectUrl = result._links.redirect.href;
          } else if (result && "redirectUrl" in result) {
              redirectUrl = result.redirectUrl;
          } else if (result && "localPayment" in result) {
              redirectUrl = result.localPayment.paymentUrl;
          } else {
              console.error(
                "capturePayment error: redirectUrl missing from response.",
                JSON.stringify(result),
              );
          }

          if (method === "card") {
            if (redirectUrl) {
              Logs.AddProvisionalEvent(`Payment show 3ds`);

              setShow3DSIframe(true);
              setIsModalOpen(true);
              const iframe = document.getElementById("3ds-iframe");
              iframe.src = redirectUrl;
            } else {

              Logs.AddProvisionalEvent(`Payment redirectURL missing`);
              showError = true;
              // Enable the form to be submitted again.
              Frames.enableSubmitForm();
            }
          } else if (
            method === "paypal" ||
            method === "giropay" ||
            method === "ideal-hosted"
          ) {
            ExitPopUp.Disable();
            window.location.href = redirectUrl;
          }
        },
        (error) => {
          Logs.AddProvisionalEvent(`Payment API - ERROR`);
          console.error(error);
        }
      );
    }
  };

  const paypalCheck = () => {
    if (activePaymentMethod === "paypal") {
      return false
    } else return true
  }

    // Once we have a card token handle it.
  useEffect(() => {

    if (activePaymentMethod === 'card' && activePaymentMethod !== "apple-pay" && activePaymentMethod !== "google-pay") {
      if ((Object.keys(orderContext).length > 0) && (cardToken !== '')) {
          Logs.AddProvisionalEvent(`CartToken and OrderContext ready, calling handlePayment`);
          handlePayment(activePaymentMethod, activePaymentAction, cardToken);
       }
      } else {
        if (Object.keys(orderContext).length > 0 && activePaymentMethod !== "apple-pay" && paypalCheck() && activePaymentMethod !== "google-pay") {
          Logs.AddProvisionalEvent(`CartToken and OrderContext ready, calling handlePayment`);
          handlePayment(activePaymentMethod, activePaymentAction, cardToken);
        }
      }
    }, [cardToken, orderContext]);



  // Update delivery and discounts if they's selected/updated.
  useEffect(() => {
    const totalDiscount = parseFloat(cartMeta.total_discount).toFixed(2);

    let sumOrderTotal = 0;

    if (cartIsSuccess) {
      sumOrderTotal = parseFloat(cartMeta.total_price);

      if (orderSummary.deliveryCharges) {
        sumOrderTotal += parseFloat(orderSummary.deliveryCharges.price);
      }
      if (totalDiscount) {
        sumOrderTotal -= totalDiscount;
      }
      if (cartMeta.is_hotel_cart && +cartMeta?.total_hotel_tax > 0) {
        sumOrderTotal += parseFloat(cartMeta.total_hotel_tax);
      }

      setAmountToPay(sumOrderTotal.toFixed(2));
    }

    if (orderSummary.paymentOption) {
      // If deposit.
      if (orderSummary.paymentOption === "deposit") {
        setAmountToPay(cartMeta.payment_options.deposittotal);
      } else if (orderSummary.paymentOption === "non-refundable-deposit") {
        setAmountToPay(cartMeta.payment_options.non_refundable_deposit?.amount.toFixed(2));
      }  else {
        setAmountToPay(sumOrderTotal.toFixed(2));
        if (total_gift_cards_balance > 0) {
          sumOrderTotal -= parseFloat(total_gift_cards_balance).toFixed(2);
          setAmountToPay(sumOrderTotal.toFixed(2));
        }
      }
    }
  }, [orderSummary]);

  useEffect(() => {
    if (cartContents) {
      setPaymentMethods(cartContents.meta.payment_methods);
    }
  }, [cartContents]);

  // AB tests
  const [isCro986, setIsCro986] = useState(false);

  useEffect(() => {
    if (abContext.cro986 !== undefined) setIsCro986(abContext.cro986.variant);
  }, [abContext]);

  // CRO-1381-checkout-redesign
  const [isCro1381, setIsCro1381] = useState(false);

  useEffect(() => {
    if ((config.brand !== 'Sw') && abContext.cro1381 !== undefined) setIsCro1381(abContext.cro1381.variant);
  }, [abContext]);
  // END CRO-1381-checkout-redesign

  // CHEC-305 Messages
  const orderStatusMessages = {
    creating: t("3ds-creating-message"),
    reviewing: t("3ds-reviewing-message")
  };

  let showError = false;
  let showSuccess = false;

  if (props.showPaymentError) {
    showError = true;
    showSuccess = false;
  } else if (props.touched) {
    // Input has been touched and is valid.
    showError = false;
    showSuccess = true;
  }

  useEffect(() => {
    if (activeTabContent === "payment-form") {
      setShowCardBlock(true);
      setShowPaypalBlock(false);
      setShowGiftCardBlock(false);
      setShowGiroPayBlock(false);
      setShowIdealPayBlock(false);
      setShowApplePay(false);
      setShowGooglePay(false);
    } else if (activeTabContent === "paypal-form") {
      setShowCardBlock(false);
      setShowGiroPayBlock(false);
      setShowGiftCardBlock(false);
      setShowIdealPayBlock(false);
      setShowPaypalBlock(true);
      setShowApplePay(false);
      setShowGooglePay(false);
    } else if (activeTabContent === "gift-form") {
      setShowCardBlock(false);
      setShowPaypalBlock(false);
      setShowGiftCardBlock(true);
      setShowIdealPayBlock(false);
      setShowGiroPayBlock(false);
      setShowApplePay(false);
      setShowGooglePay(false);
    } else if (activeTabContent === "giropay-form") {
      setShowCardBlock(false);
      setShowPaypalBlock(false);
      setShowGiftCardBlock(false);
      setShowIdealPayBlock(false);
      setShowGiroPayBlock(true);
      setShowApplePay(false);
      setShowGooglePay(false);
    } else if (activeTabContent === "ideal-form") {
      setShowCardBlock(false);
      setShowPaypalBlock(false);
      setShowGiftCardBlock(false);
      setShowGiroPayBlock(false);
      setShowIdealPayBlock(true);
      setShowApplePay(false);
      setShowGooglePay(false);
    }
    else if (activeTabContent === "apple-pay") {
      setShowCardBlock(false);
      setShowPaypalBlock(false);
      setShowGiftCardBlock(false);
      setShowGiroPayBlock(false);
      setShowIdealPayBlock(false);
      setShowApplePay(true);
      setShowGooglePay(false);
    }
    else if (activeTabContent === "google-pay") {
      setShowCardBlock(false);
      setShowPaypalBlock(false);
      setShowGiftCardBlock(false);
      setShowGiroPayBlock(false);
      setShowIdealPayBlock(false);
      setShowApplePay(false);
      setShowGooglePay(true);
    }
  }, [activeTabContent, depDate]);

  // Clear external payment errors when payment method is changed
  useEffect(() => {
    props.setShowExternalPaymentError(false)
  },[activePaymentMethod])

  useEffect(() => {
    // Checking in any tickets in Cart is dated, if it is, check if date on any of the dated tickets is shorter than payPalLimitDays.
    // In this case we are using this function do display PayPal payments option, as PayPal is creating issues for CS due to email mismatches and potential fraud.
    // Business decision is to hide it for anyone traveling/needing tickets within 72 hours.
    const checkForDatedTickets = () => {
      if (cartIsSuccess){
      const isInRange = cartContents.data.tickets.some( ticket => {
          if (ticket.hasOwnProperty('date')) {
            if(differenceInCalendarDays(new Date(parseISO(ticket.date)), new Date()) <= payPalLimitDays) {
              return true;
            }
          }
          return false;
        })
        setShowPayPal(isInRange)
      }
    };

    if (cartIsSuccess) checkForDatedTickets();

  },[cartIsSuccess])

  // Payment Tabs
  const Tabs = (props) => {
    const handleTabClick = (paymentType) => {
      setActiveTab(paymentType.formid);
      setActiveTabContent(paymentType.formid);
      setActivePaymentMethod(paymentType.id);
      if (paymentType.id === "card") {
        setActivePaymentAction(paymentType.id);
      } else {
        setActivePaymentAction("payment");
        setCardToken("");
      }
    };

  if (!props.payment_methods.some((method) => method.id.includes("google-pay"))) {
    const tabOrder = applePayAvailable() ? 2 : 1;
    props.payment_methods.splice(tabOrder, 0, {
      formid: "google-pay",
      id: "google-pay",
      title: "Google Pay",
      uses_iframe: 0,
    });
  }

    props.payment_methods.map( (method,index) => {
      if(method.id === 'gift-card') {
        const gifCard = method;
        props.payment_methods.splice(index,1);
        props.payment_methods.push(gifCard);
      }
      return '';
    })

    return (
      <>
        {props.payment_methods.map((paymentType, index) => {
         if (((props.selectedCountry !== 'Netherlands') && paymentType.id === 'ideal-hosted') || ((props.selectedCountry !== 'Germany') && paymentType.id === 'giropay') || (paymentType.id === 'paypal' && (!depDate || differenceInCalendarDays(new Date(props.depDate), new Date()) < payPalLimitDays)) || (paymentType.id === 'paypal' && props.showPayPal) || (paymentType.id === 'paypal-t')) {
          setShowPaypalBlock(false);
          return '';
         } else {
          return (
            <div className={props.styles.tabTab} key={index}>
              <div
                href=""
                id={paymentType.id + "-t"}
                key={index}
                onClick={() => handleTabClick(paymentType)}
                className={
                  activeTab === paymentType.formid
                    ? props.styles.tabLinkSelected
                    : props.styles.tabLink
                }
              >
                {paymentType.id === "card" && <CardIcon />}
                {paymentType.id === "gift-card" && <GiftIcon />}
                {t(paymentType.title)}
              </div>
            </div>
          );
         }
        })}
      </>
    );
  };

  // Once we have a order handle it.
  useEffect(() => {
    if (Object.keys(orderContext).length > 0) {
      if (activePaymentMethod === "gift-card") {
        if (
          cartContents.meta.total_gift_card_balance >= parseFloat(amountToPay)
        ) {
          applyGiftCards(
            orderContext.orderId,
            cartContents.data.gift_cards,
            cartContents.meta.total_price
          );
          // Make session id available to the page being redirected to:
          config.brand === "Atd" && API.delete("/cart");
          window.localStorage.setItem("sid", orderContext.sid);

          Cookies.set('orderDoComplete',true);
          Cookies.set('risk',false);
          Cookies.set('flagged',false);
          Cookies.set('display',true);

          // Redirect:
          const redirectPath =
          config.checkoutCompleteBaseUrl +
          `${getLanguageCode(config.brand, true)}/cart/checkout/complete/${
            orderContext.orderId
          }`;
          ExitPopUp.Disable();
          window.location.href = redirectPath;
        }
      }
    }
  }, [orderContext]);

  function applePayAvailable() {
    try{
       // eslint-disable-next-line no-undef
      return window.ApplePaySession && ApplePaySession.canMakePayments();
    } catch(e) {
      return false;
    }
  };

  const GiroPay = (props) => {
    return (
      <>
        <div id="checkout-giropay-section">
          <div class="checkout-payment-section">
            <iframe
              title="giropay"
              id="checkoutdotcom-giropay-iframe"
              name="giropay_frame"
              src=""
              frameborder="0"
              height="0"
            ></iframe>
          </div>
        </div>
        <div class="payment-logo">
          <img
            src="/themes/custom/atd/images/giropay_logo.png"
            class="giropay_new_logo"
            alt="Giropay"
          />
        </div>
        <div class="text">
          {paymentError && (
            <p id="payment-error-giropay" class="form-item__validation">
              <span class="msg">
                We were unable to process your payment. If the problem persists,
                please contact us to complete your order.
              </span>
            </p>
          )}
          <p>{t('to-continue')}</p>
        </div>
      </>
    );
  };

  const IdealPay = (props) => {
    return (
      <>
        <img src={idealLogo} alt="iDEAL" />
        <div class="payment-continue-text">
          {paymentError && (
            <p id="payment-error-ideal-hosted" class="form-item__validation">
              <span class="msg">
                We were unable to process your payment. If the problem persists,
                please contact us to complete your order.
              </span>
            </p>
          )}
          <p>To continue, please click 'Book Now' below.</p>
        </div>
      </>
    );
  };

  useEffect(() => {
    if(cartIsSuccess) {
      googleDataLayer.createPaymentMethodChoiceEvent(activePaymentMethod)
    }
  }, [activePaymentMethod,cartIsSuccess])

  const [showAmexError, setAmexCardError] = useState(false);
  const paymentsAccepted = ['Visa', 'Maestro', 'Mastercard'];

  const shouldHideAmex = () => {
    return config.brand === 'Aa' || country_code === 'AU' || country_code === 'US' ? false : true;
  }

  if((config.brand !== 'Aa') && (country_code !== 'AU') && (country_code !== 'US')) {
    paymentsAccepted.push('American Express');
  }

  // CRO-1381 Redesign
  const initialValidationState = {
    'card-number': { isValid: true, interacted: false, isDirty: false, hasFocusedOut: false, showValidation: false },
    'expiry-date': { isValid: true, interacted: false, isDirty: false, hasFocusedOut: false, length: 0, showValidation: false },
    'cvv': { isValid: true, interacted: false, isDirty: false, hasFocusedOut: false, length: 0, showValidation: false }
  };

  const resetValidationCardRedesign = () => {
    setValidationState(initialValidationState);
    setAmexCardError(false);
    setCardType("");
    props.setShowPaymentError(false);
  };

  const handleRadioClick = (paymentType) => {
      setActiveTab(paymentType.formid);
      setActiveTabContent(paymentType.formid);
      setActivePaymentMethod(paymentType.id);
      resetValidationCardRedesign();
      if (paymentType.id === "apple-pay" && applePayAvailable()) {
        setActivePaymentAction(paymentType.id);
      } else if (paymentType.id === "card") {
        setActivePaymentAction(paymentType.id);
      } else {
        setActivePaymentAction("payment");
        setCardToken("");
      }
  };

  // Card icons for Checkout.com
  const [cardType, setCardType] = useState("");
  const [validationError, setValidationError] = useState("");

  const cardIcons = {
    visa: visaIcon,
    mastercard: mastercardIcon,
    amex: amexIcon,
    dinersclub: dinersclubIcon,
    discover: discoverIcon,
    jcb: jcbIcon,
    mada: madaIcon,
    maestro: maestroIcon,
    cardError: cardErrorIcon,
  };

  // Making ApplePay the default option if ApplePay is available
  const [applePayDefaultSet, setApplePayDefaultSet] = useState(false);

  useEffect(() => {
    if (isCro1381 && applePayAvailable() && !applePayDefaultSet) {
      setActivePaymentMethod("apple-pay");
      setActiveTab("apple-pay");
      setActiveTabContent("apple-pay");
      setActivePaymentAction("apple-pay");
      setApplePayDefaultSet(true);
    }
  }, [isCro1381]);
  // CRO-1381 Redesign End

  const resetCardValidationErrors = () => {
    // Need if statements to prevent multiple rerender errors
    if (showCardValidationError) {
      setShowCardValidationError(false)
    }
    if (showCardExpiryValidationError) {
      setShowCardCvvValidationError(false)
    }
    if (showCardCvvValidationError) {
      setShowCardExpiryValidationError(false)
    }
    if (showAmexError) {
      setAmexCardError(false)
    }
  }

  if (applePayAvailable() && !payment_methods.some(method => method.id.includes("apple-pay"))) {
    payment_methods.splice(1, 0, {
      formid: "apple-pay",
      id: "apple-pay",
      title: "ApplePay",
      uses_iframe: 0
    });
  }

  if (!payment_methods.some((method) => method.id.includes("google-pay"))) {
    const tabOrder = applePayAvailable() ? 2 : 1;
    payment_methods.splice(tabOrder, 0, {
      formid: "google-pay",
      id: "google-pay",
      title: "Google Pay",
      uses_iframe: 0,
    });
  }

  // Switching payment method to card when departure date is less than 3 days from date
  useEffect(() => {
    if (depDate && differenceInCalendarDays(new Date(depDate), new Date()) < payPalLimitDays) {
      const cardPaymentType = payment_methods.find(method => method.id === 'card');
      if (cardPaymentType) {
        handleRadioClick(cardPaymentType);
        setValidationState(initialValidationState);
      }
    }
  }, [depDate, payPalLimitDays]);

  // Validation for redesign so error messages show after blur, not straightaway
  const [validationState, setValidationState] = useState(initialValidationState);

  return (
    <>
      <StandardFieldset id="payment-pane">
        {isCro1381 ? (
          <div
            ref={props.paymentDetailsTitleRef}
            className={styles.cro1381PaymentSecure}
          >
            <StandardH2 className="cro1381H2 cro1381NoMar">
              {t("payment-details")}
            </StandardH2>
            <div className={styles.cro1381SecureContent}>
              <LockIcon />
              <span>{t("secure-checkout")}</span>
            </div>
          </div>
        ) : (
          <div ref={props.paymentDetailsTitleRef}>
            <StandardH2>{t("payment-details")}</StandardH2>
          </div>
        )}

        {props.showExternalPaymentError ? (
          <div ref={props.externalPaymentPayMessageRef}>
            <div className={styles.failedPaymentMessage}>
              <img
                src={AlertTriangle}
                className={styles.alertIcon}
                alt="orange alert triangle"
              />
              <div className={styles.failedPaymentTextContainer}>
                <p className={styles.failedPaymentTextBold}>
                  {t("lets-try-that-again")}
                </p>
                <p className={styles.failedPaymentText}>
                  {t("unable-to-process-payment")}
                </p>
              </div>
            </div>
          </div>
        ) : null}
        {isCro1381 ? (
          <div className={styles.cro1381PaymentContainer}>
            {payment_methods.map((paymentType, index) => {
              if (
                (props.selectedCountry !== "Netherlands" &&
                  paymentType.id === "ideal-hosted") ||
                (props.selectedCountry !== "Germany" &&
                  paymentType.id === "giropay") ||
                (paymentType.id === "paypal" &&
                  (!depDate ||
                    differenceInCalendarDays(new Date(depDate), new Date()) <
                      payPalLimitDays)) ||
                (paymentType.id === "paypal" && showPayPal) ||
                paymentType.id === "paypal-t"
              ) {
                return null;
              }
              return (
                <div
                  className={`${styles.cro1381PaymentHolder} ${
                    paymentType.id === "apple-pay"
                      ? styles.cro1381ApplepayOrder
                      : paymentType.id === "gift-card"
                      ? styles.cro1381GiftCardOrder
                      : ""
                  }
                  ${activeTab === paymentType.formid ? styles.active : ""}
                `}
                  key={index}
                >
                  <button
                    type="button"
                    id={paymentType.id + "-t"}
                    onClick={() => {
                      handleRadioClick(paymentType);
                      googleDataLayer.createUserClickInputEvent(
                        `${paymentType}MethodChosen`
                      );
                    }}
                    className={
                      styles.cro1381PaymentLink +
                      " " +
                      (activeTab === paymentType.formid &&
                        styles.cro1381PaymentLinkActive)
                    }
                  >
                    <span className={styles.cro1381RadioOuter}>
                      <span
                        className={
                          activeTab === paymentType.formid &&
                          styles.cro1381RadioInner
                        }
                      ></span>
                    </span>
                    {paymentType.id === "apple-pay" && (
                      <>
                        ApplePay{" "}
                        <span className={styles.cro1381PaymentRghtCol}>
                          <span>
                            <Cro1381ApplePayIcon />
                          </span>
                        </span>
                      </>
                    )}
                    {paymentType.id === "paypal" && (
                      <>
                        {t("paypal")}{" "}
                        <span
                          className={`${styles.cro1381PaymentRghtCol} ${styles.cro1381PaymentRghtColBreak}`}
                        >
                          <span>
                            <Cro1381PaypalIcon />
                          </span>
                        </span>
                      </>
                    )}
                    {paymentType.id === "card" && (
                      <>
                        {t("credit-card")}{" "}
                        <span
                          className={`${styles.cro1381PaymentRghtCol} ${styles.cro1381PaymentRghtColBreak}`}
                        >
                          <div className={styles.cro1381PaymentCards}>
                            <Cro1381CardVisaIcon />
                            <Cro1381CardMastercardIcon />
                            {shouldHideAmex() && <Cro1381CardAmexIcon data-testid="amex-icon"/>}
                          </div>
                        </span>
                      </>
                    )}
                    {paymentType.id === "gift-card" && (
                      <>
                        {t("gift-card")}{" "}
                        <span className={styles.cro1381PaymentRghtCol}>
                          <Cro1381BlackGiftIcon />
                        </span>
                      </>
                    )}
                    {paymentType.id === "giropay" && (
                      <>
                        Giropay{" "}
                        <span className={styles.cro1381PaymentRghtCol}>
                          <span>
                            <Cro1381GiroPayIcon />
                          </span>
                        </span>
                      </>
                    )}
                    {paymentType.id === "ideal-hosted" && (
                      <>
                        IdealPay{" "}
                        <span className={styles.cro1381PaymentRghtCol}>
                          <span>
                            <Cro1381IdealIcon />
                          </span>
                        </span>
                      </>
                    )}
                    {paymentType.id === "google-pay" && (
                      <>
                        Google Pay{" "}
                        <span className={styles.cro1381PaymentRghtCol}>
                          <span className={styles.gpayIcon}>
                            <Cro1381GooglePayIcon />
                          </span>
                        </span>
                      </>
                    )}
                  </button>

                  {activeTab === paymentType.formid && (
                    <div className={styles.cro1381PaymentContent}>
                      {paymentType.id === "apple-pay" && (
                        <ApplePayTabInfo
                          paymentFailed={props.applePayFailed}
                          showMessage={props.showExternalPaymentPayMessage}
                          isFormSubmitted={props.isFormSubmitted}
                        />
                      )}
                      {paymentType.id === "card" && (
                        <>
                          {!show3DSIframe && (
                            <div
                              id="payment-form"
                              method="POST"
                              action=""
                              target="creditcard_frame"
                            >
                              {publicKey && (
                                <div className={styles.cro1381cardHolder}>
                                  <div className={styles.cro1381CardNumber}>
                                    <div className="card-number-frame"></div>
                                    {cardType && !validationError && (
                                      <>
                                        {cardType.toLowerCase() ===
                                        "american express" ? (
                                          <img
                                            src={amexIcon}
                                            alt="American Express"
                                            className={styles.cro1381CardImage}
                                          /> // Explicitly adding amex because normal integration doesn't work
                                        ) : (
                                          <img
                                            src={
                                              cardIcons[cardType.toLowerCase()]
                                            }
                                            alt={cardType}
                                            className={styles.cro1381CardImage}
                                          />
                                        )}
                                      </>
                                    )}
                                    {validationError && (
                                      <img
                                        src={cardIcons[validationError]}
                                        alt="Error"
                                        className={styles.cro1381CardImage}
                                      />
                                    )}
                                  </div>
                                  <div className={styles.cro1381CardDate}>
                                    <div className="expiry-date-frame"></div>
                                  </div>
                                  <div className={styles.cro1381CardCVV}>
                                    <div className="cvv-frame"></div>
                                  </div>
                                  <Frames
                                    config={{
                                      // debug: true,
                                      cardholder: {
                                        name: cardholder.name,
                                        phone: cardholder.phone,
                                        addressLine1: cardholder.addressLine1,
                                        addressLine2: cardholder.addressLine2,
                                        city: cardholder.city,
                                        zip: cardholder.zip,
                                        state: cardholder.state,
                                        country: cardholder.country,
                                      },
                                      publicKey: publicKey,
                                      acceptedPaymentMethods: paymentsAccepted,
                                      localization: {
                                        cardNumberPlaceholder: t("card-number"),
                                        expiryMonthPlaceholder: "MM",
                                        expiryYearPlaceholder: t("YY"),
                                        cvvPlaceholder: "CVV",
                                      },
                                      style: {
                                        base: {
                                          fontSize: "16px",
                                          backgroundColor: "transparent",
                                        },
                                      },
                                    }}
                                    ready={() => {}}
                                    frameActivated={(e) => {}}
                                    frameFocus={(e) => {
                                      setValidationState((prevState) => ({
                                        ...prevState,
                                        [e.element]: {
                                          ...prevState[e.element],
                                          interacted: true,
                                          hasFocusedOut: false,
                                        },
                                      }));
                                    }}
                                    frameValidationChanged={(e) => {
                                      setValidationState((prevState) => {
                                        const newLength =
                                          e.element === "cvv" ||
                                          e.element === "expiry-date"
                                            ? e.value
                                              ? e.value.length
                                              : 0
                                            : prevState[e.element].length;
                                        const showValidation =
                                          prevState[e.element].showValidation ||
                                          (e.element === "cvv" &&
                                            newLength >= 3) ||
                                          (e.element === "expiry-date" &&
                                            newLength >= 4) ||
                                          (prevState[e.element].hasFocusedOut &&
                                            !e.isValid);
                                        return {
                                          ...prevState,
                                          [e.element]: {
                                            ...prevState[e.element],
                                            isValid: e.isValid,
                                            interacted: true,
                                            isDirty: true,
                                            length: newLength,
                                            showValidation: showValidation,
                                          },
                                        };
                                      });
                                    }}
                                    frameBlur={(e) => {
                                      setValidationState((prevState) => ({
                                        ...prevState,
                                        [e.element]: {
                                          ...prevState[e.element],
                                          hasFocusedOut: true,
                                          showValidation:
                                            prevState[e.element]
                                              .showValidation ||
                                            !prevState[e.element].isValid,
                                        },
                                      }));
                                    }}
                                    paymentMethodChanged={(e) => {
                                      if (
                                        !e.isPaymentMethodAccepted &&
                                        e.paymentMethod
                                      ) {
                                        setAmexCardError(true);
                                        setPaymentIsValid(false);
                                        setCardAccepted(false);
                                        setCardType(""); // Reset card type if not accepted
                                      } else if (
                                        e.isPaymentMethodAccepted &&
                                        e.paymentMethod
                                      ) {
                                        setAmexCardError(false);
                                        setCardAccepted(true);
                                        props.setShowPaymentError(false);
                                        setCardType(e.paymentMethod); // Update card type
                                      } else if (
                                        e.paymentMethod === undefined
                                      ) {
                                        setAmexCardError(false);
                                        props.setShowPaymentError(false);
                                        props.setShowExternalPaymentError(
                                          false
                                        );
                                        setCardType(""); // Reset card type if undefined
                                      }
                                    }}
                                    cardValidationChanged={(e) => {
                                      setPaymentIsValid(e.isValid);
                                    }}
                                    cardSubmitted={() => {}}
                                    cardTokenized={(e) => {
                                      Logs.AddProvisionalEvent(
                                        `Card token created`
                                      );
                                      setCardToken(e.token);
                                    }}
                                    cardTokenizationFailed={(e) => {}}
                                  >
                                    <CardNumber className={styles.cardNumber} />
                                    <ExpiryDate className={styles.cardDate} />
                                    <Cvv className={styles.cardCvv} />
                                  </Frames>
                                </div>
                              )}

                              {showSuccess && (
                                <StandardValidation
                                  valType="success"
                                  className="input"
                                ></StandardValidation>
                              )}
                              {showError && (
                                <StandardValidation
                                  className="input"
                                  valType="error"
                                  id="payment-failed"
                                >
                                  {t("unable-to-process-card-payment")}
                                </StandardValidation>
                              )}
                              {showAmexError && (
                                <StandardValidation
                                  className="input"
                                  valType="error"
                                  id="payment-failed"
                                >
                                  <span data-testid="amex-error-message">{t("don't-accept-amex-message")}</span>
                                </StandardValidation>
                              )}
                              {validationState["card-number"].showValidation &&
                                !validationState["card-number"].isValid && (
                                  <StandardValidation
                                    className="input"
                                    valType="error"
                                    id="payment-failed"
                                  >
                                    {t(
                                      "your-card-number-is-invalid-or-incomplete"
                                    )}
                                  </StandardValidation>
                                )}

                              {validationState["expiry-date"].showValidation &&
                                !validationState["expiry-date"].isValid && (
                                  <StandardValidation
                                    className="input"
                                    valType="error"
                                    id="payment-failed"
                                  >
                                    {t(
                                      "your-cards-expiry-is-in-the-past-or-incomplete"
                                    )}
                                  </StandardValidation>
                                )}

                              {validationState["cvv"].showValidation &&
                                !validationState["cvv"].isValid && (
                                  <StandardValidation
                                    className="input"
                                    valType="error"
                                    id="payment-failed"
                                  >
                                    {t(
                                      "your-cards-security-code-is-incomplete"
                                    )}
                                  </StandardValidation>
                                )}
                              <StandardH3>
                                <a
                                  href="#cvv-info-block"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setShowCVVInfo(!showCVVInfo);
                                  }}
                                >
                                  {t("whats-the-cvv")}
                                </a>
                              </StandardH3>

                              {showCVVInfo && (
                                <StandardBlockInfo id="cvv-info-block">
                                  <p>
                                    {t(
                                      "cvv-stands-for-card-verification-value-this-number"
                                    )}
                                  </p>
                                  <StandardH4>Visa, Mastercard</StandardH4>
                                  <p>
                                    <img
                                      src={CvvImg}
                                      alt=""
                                      className={styles.cvvImage}
                                    />
                                    {t(
                                      "the-cvv-for-these-cards-is-found-on-the-back-side"
                                    )}
                                  </p>
                                </StandardBlockInfo>
                              )}

                              <p>{t("card-proceed-message")}</p>
                            </div>
                          )}

                          {config.brand !== 'Sw'
                            ? props.message3DSShowModal && (
                                <ReactModal
                                  isOpen={props.message3DSShowModal}
                                  onRequestClose={() => setShow3DSIframe(false)}
                                  className={styles.modal}
                                  overlayClassName={styles.modalOverlay}
                                  shouldCloseOnOverlayClick={false}
                                  shouldCloseOnEsc={false}
                                  onAfterOpen={() =>
                                    (document.body.style.overflow = "hidden")
                                  }
                                  onAfterClose={() =>
                                    (document.body.style.overflow = "unset")
                                  }
                                >
                                  <div className={styles.message3DSContainer}>
                                    {!show3DSIframe && (
                                      <div className={styles.message3DSContent}>
                                        <Messaging3DSLogoIcon />
                                        {props.orderCreationStatus ===
                                        "callback" ? (
                                          <>
                                            <p>{t("3ds-couldnt-process-1")}</p>
                                            <p>
                                              {t("3ds-couldnt-process-2")}{" "}
                                              <a
                                                href="#"
                                                onClick={
                                                  props.handleClose3DSModal
                                                }
                                              >
                                                {t(
                                                  "3ds-couldnt-process-tryagain-link"
                                                )}
                                              </a>{" "}
                                              {t("3ds-couldnt-process-3")}{" "}
                                              <a href="../../contact-us">
                                                {t(
                                                  "3ds-couldnt-process-contact-link"
                                                )}
                                              </a>{" "}
                                              {t("3ds-couldnt-process-4")}
                                            </p>
                                          </>
                                        ) : (
                                          <p>
                                            {
                                              orderStatusMessages[
                                                props.orderCreationStatus
                                              ]
                                            }
                                          </p>
                                        )}
                                        {props.orderCreationStatus !==
                                          "callback" && (
                                          <div
                                            className={styles.dotFlashing}
                                          ></div>
                                        )}
                                      </div>
                                    )}
                                    {show3DSIframe && (
                                      <div className={styles.message3DSIframe}>
                                        <iframe
                                          id="3ds-iframe"
                                          title="checkout.com 3ds iframe"
                                          allow="payment *"
                                          className={styles.paymentFrame}
                                        ></iframe>
                                      </div>
                                    )}
                                    <div id="card"></div>
                                  </div>
                                </ReactModal>
                              )
                            : show3DSIframe && (
                                <iframe
                                  id="3ds-iframe"
                                  title="checkout.com 3ds iframe"
                                  allow="payment *"
                                  className={styles.paymentFrame}
                                ></iframe>
                              )}
                        </>
                      )}
                      {paymentType.id === "paypal" && (
                        <PaypalV3
                          isFormValid={props.isFormValid}
                          submittingForm={props.submittingForm}
                          styles={styles}
                          amountToPay={amountToPay}
                          showFormFunc={props.showFormFunc}
                          isCro1381={isCro1381}
                          shouldLoadPaypal={props.shouldLoadPaypal}
                          setOrder={props.setOrder}
                          setOrderCreationStatus={props.setOrderCreationStatus}
                          setOpenModal={props.setOpenModal}
                          setShowExternalPaymentError={props.setShowExternalPaymentError}
                        />
                      )}
                      {paymentType.id === "giropay" && (
                        <GiroPay styles={styles} />
                      )}
                      {paymentType.id === "ideal-hosted" && (
                        <IdealPay styles={styles} />
                      )}
                      {paymentType.id === "gift-card" && <GiftCard />}
                      {paymentType.id === "google-pay" && (
                        <GooglePayInfo
                          paymentFailed={props.externalPayFailed}
                          showMessage={props.showExternalPaymentPayMessage}
                          paymentMethod={activeTab}
                          isFormSubmitted={props.isFormSubmitted}
                          setShowExternalPaymentError={props.setShowExternalPaymentError}
                        />
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
         ) : (
          <>
            <div className={styles.tabsWrapper}>
              <Tabs
                styles={styles}
                selectedCountry={props.selectedCountry}
                payment_methods={
                  payment_methods.length > 0 ? payment_methods : []
                }
                depDate={depDate}
                showPayPal={showPayPal}
              />
            </div>
            <div className={styles.tabContent}>
              {loading && !config.brand === "Atd" && (
                <div className={styles.loading_overlay}>
                  <div className={styles.loading_circle} />
                </div>
              )}

              {showCardBlock && (
                <>
                  {!show3DSIframe && (
                    <div
                      id="payment-form"
                      method="POST"
                      action=""
                      target="creditcard_frame"
                    >
                      {publicKey && (
                        <div className={styles.cardHolder}>
                          <div className="card-frame">
                            <Frames
                              config={{
                                // debug: true,
                                cardholder: {
                                  name: cardholder.name,
                                  phone: cardholder.phone,
                                  addressLine1: cardholder.addressLine1,
                                  addressLine2: cardholder.addressLine2,
                                  city: cardholder.city,
                                  zip: cardholder.zip,
                                  state: cardholder.state,
                                  country: cardholder.country,
                                },
                                publicKey: publicKey,
                                acceptedPaymentMethods: paymentsAccepted,
                                localization: {
                                  cardNumberPlaceholder: t("card-number"),
                                  expiryMonthPlaceholder: "MM",
                                  expiryYearPlaceholder: t("YY"),
                                  cvvPlaceholder: "CVV",
                                },
                                style: {
                                  base: {
                                    fontSize: "17px",
                                    width: "64px",
                                    backgroundColor: "transparent",
                                  },
                                },
                              }}
                              ready={() => {}}
                              frameActivated={(e) => {}}
                              frameFocus={(e) => {}}
                              frameBlur={(e) => {}}
                              frameValidationChanged={(e) => {
                                if (e.element === "card-number") {
                                  setShowCardValidationError(!e.isValid);
                                }
                                if (e.element === "expiry-date") {
                                  setShowCardExpiryValidationError(!e.isValid);
                                }
                                if (e.element === "cvv") {
                                  setShowCardCvvValidationError(!e.isValid);
                                }
                              }}
                              paymentMethodChanged={(e) => {
                                if (
                                  !e.isPaymentMethodAccepted &&
                                  e.paymentMethod
                                ) {
                                  setAmexCardError(true);
                                  setPaymentIsValid(false);
                                  setCardAccepted(false);
                                } else if (
                                  e.isPaymentMethodAccepted &&
                                  e.paymentMethod
                                ) {
                                  setAmexCardError(false);
                                  setCardAccepted(true);
                                  props.setShowPaymentError(false);
                                } else if (e.paymentMethod === undefined) {
                                  setAmexCardError(false);
                                  props.setShowPaymentError(false);
                                }
                              }}
                              cardValidationChanged={(e) => {
                                setPaymentIsValid(e.isValid);
                              }}
                              cardSubmitted={() => {}}
                              cardTokenized={(e) => {
                                Logs.AddProvisionalEvent(`Card token created`);
                                setCardToken(e.token);
                              }}
                              cardTokenizationFailed={() => {}}
                            >
                              <CardNumber className={styles.cardNumber} />
                              <ExpiryDate className={styles.cardDate} />
                              <Cvv className={styles.cardCvv} />
                            </Frames>
                          </div>
                        </div>
                      )}

                      {showSuccess && (
                        <StandardValidation
                          valType="success"
                          className="input"
                        ></StandardValidation>
                      )}
                      {showError && (
                        <StandardValidation
                          className="input"
                          valType="error"
                          id="payment-failed"
                        >
                          {t("unable-to-process-card-payment")}
                        </StandardValidation>
                      )}
                      {showAmexError && (
                        <StandardValidation
                          className="input"
                          valType="error"
                          id="payment-failed"
                        >
                          {t("don't-accept-amex-message")}
                        </StandardValidation>
                      )}
                      {showCardValidationError && (
                        <StandardValidation
                          className="input"
                          valType="error"
                          id="payment-failed"
                        >
                          {t("your-card-number-is-invalid-or-incomplete")}
                        </StandardValidation>
                      )}
                      {showCardExpiryValidationError && (
                        <StandardValidation
                          className="input"
                          valType="error"
                          id="payment-failed"
                        >
                          {t("your-cards-expiry-is-in-the-past-or-incomplete")}
                        </StandardValidation>
                      )}
                      {showCardCvvValidationError && (
                        <StandardValidation
                          className="input"
                          valType="error"
                          id="payment-failed"
                        >
                          {t("your-cards-security-code-is-incomplete")}
                        </StandardValidation>
                      )}

                      <StandardH3>
                        <a
                          href="#cvv-info-block"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowCVVInfo(!showCVVInfo);
                          }}
                        >
                          {t("whats-the-cvv")}
                        </a>
                      </StandardH3>

                      {showCVVInfo && (
                        <StandardBlockInfo id="cvv-info-block">
                          <p>
                            {t(
                              "cvv-stands-for-card-verification-value-this-number"
                            )}
                          </p>
                          <StandardH4>Visa, Mastercard</StandardH4>
                          <p>
                            <img
                              src={CvvImg}
                              alt=""
                              className={styles.cvvImage}
                            />
                            {t(
                              "the-cvv-for-these-cards-is-found-on-the-back-side"
                            )}
                          </p>
                        </StandardBlockInfo>
                      )}
                    </div>
                  )}

                  {config.brand !== 'Sw'
                    ? props.message3DSShowModal && (
                        <ReactModal
                          isOpen={props.message3DSShowModal}
                          onRequestClose={() => setShow3DSIframe(false)}
                          className={styles.modal}
                          overlayClassName={styles.modalOverlay}
                          shouldCloseOnOverlayClick={false}
                          shouldCloseOnEsc={false}
                          onAfterOpen={() =>
                            (document.body.style.overflow = "hidden")
                          }
                          onAfterClose={() =>
                            (document.body.style.overflow = "unset")
                          }
                        >
                          <div className={styles.message3DSContainer}>
                            {!show3DSIframe && (
                              <div className={styles.message3DSContent}>
                                <Messaging3DSLogoIcon />
                                {props.orderCreationStatus === "callback" ? (
                                  <>
                                    <p>{t("3ds-couldnt-process-1")}</p>
                                    <p>
                                      {t("3ds-couldnt-process-2")}{" "}
                                      <a
                                        href="#"
                                        onClick={props.handleClose3DSModal}
                                      >
                                        {t("3ds-couldnt-process-tryagain-link")}
                                      </a>{" "}
                                      {t("3ds-couldnt-process-3")}{" "}
                                      <a href="../../contact-us">
                                        {t("3ds-couldnt-process-contact-link")}
                                      </a>{" "}
                                      {t("3ds-couldnt-process-4")}
                                    </p>
                                  </>
                                ) : (
                                  <p>
                                    {
                                      orderStatusMessages[
                                        props.orderCreationStatus
                                      ]
                                    }
                                  </p>
                                )}
                                {props.orderCreationStatus !== "callback" && (
                                  <div className={styles.dotFlashing}></div>
                                )}
                              </div>
                            )}
                            {show3DSIframe && (
                              <div className={styles.message3DSIframe}>
                                <iframe
                                  id="3ds-iframe"
                                  allow="payment *"
                                  title="checkout.com 3ds iframe"
                                  className={styles.paymentFrame}
                                ></iframe>
                              </div>
                            )}
                            <div id="card"></div>
                          </div>
                        </ReactModal>
                      )
                    : show3DSIframe && (
                        <iframe
                          id="3ds-iframe"
                          allow="payment *"
                          title="checkout.com 3ds iframe"
                          className={styles.paymentFrame}
                        ></iframe>
                      )}
                </>
              )}
              {/*Paypal V3 section*/}
              {showPaypalBlock && (
                <PaypalV3
                  isFormValid={props.isFormValid}
                  submittingForm={props.submittingForm}
                  styles={styles}
                  amountToPay={amountToPay}
                  showFormFunc={props.showFormFunc}
                  isCro1381={isCro1381}
                  shouldLoadPaypal={props.shouldLoadPaypal}
                  setOrder={props.setOrder}
                  setOrderCreationStatus={props.setOrderCreationStatus}
                  setOpenModal={props.setOpenModal}
                  setShowExternalPaymentError={props.setShowExternalPaymentError}
                />
              )}
              {/* GiroPay section */}
              {showGiroPayBlock && <GiroPay styles={styles} />}
              {/* IdealPay section */}
              {showIdealPayBlock && <IdealPay styles={styles} />}
              {showGiftCardBlock && <GiftCard />}
              {showApplePay && (
                <ApplePayTabInfo
                  paymentFailed={props.applePayFailed}
                  showMessage={props.showExternalPaymentPayMessage}
                  isFormSubmitted={props.isFormSubmitted}
                />
              )}
              {showGooglePay && (
                <GooglePayInfo
                  paymentFailed={props.externalPayFailed}
                  showMessage={props.showExternalPaymentPayMessage}
                  paymentMethod={activeTab}
                  isFormSubmitted={props.isFormSubmitted}
                  setShowExternalPaymentError={props.setShowExternalPaymentError}
                />
              )}
              {/* Reset card frame validation errors */}
              {showPaypalBlock ||
              showGiroPayBlock ||
              showIdealPayBlock ||
              showGiftCardBlock ||
              showGooglePay ||
              showApplePay
                ? resetCardValidationErrors()
                : null}
            </div>
          </>
        )}
        <div id="checkout-messages"></div>
        <SubTotal id="checkout-amount-details2" className="bodyTableHolder" />
      </StandardFieldset>

      {isCro986 && (
        <div className="card card__blue card__info">
          <p className="card_subtitle">{t("flexi-plus-cancelation-message")}</p>
        </div>
      )}
    </>
  );
};

export default PaymentDetails;
